module.exports = __webpack_public_path__ + "assets/images/template/project/wuhan_zoomin.gif?v=01a5b927";